import { WagmiProvider } from "wagmi";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { createAirdaoConfig } from "@airdao/ui-library";

const queryClient = new QueryClient();

const { REACT_APP_WC_PROJECT_ID: projectId, REACT_APP_CHAIN_ID: chainId } =
  process.env;

const WC_PARAMS = {
  projectId: projectId,
  metadata: {
    name: "AirDAO Staking",
    description:
      "AirDAO Stake is staking simplified on the Ambrosus network. Earn rewards by staking and securing the network. Rewards are distributed every 6 hours.",
    url: "https://airdao.io/staking",
  },
};

const config = createAirdaoConfig(WC_PARAMS, +chainId);

export default function ConfiguredWagmiProvider({ children }) {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </WagmiProvider>
  );
}
